import React from 'react'
import SearchContextProvider from '../store/search-context'
import Main from '../components/Search/Main'
import PaginationContextProvider from '../store/pagination-context'


const Search = () => {
    return (
        <div className="container bodyContainer">
            <h1 className="page-heading page-header">Search</h1>
            <div className={`row`}>
                <SearchContextProvider>
                    <PaginationContextProvider>
                        <Main />
                    </PaginationContextProvider>
                </SearchContextProvider>
            </div>
        </div>
    )
}

export default Search